module.exports = __webpack_public_path__ + "static/media/glassEndCap.418a507b.png";